import { useRouter } from '@/src/store/router/RouterProvider';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';
import React, { cloneElement, forwardRef, ReactElement } from 'react';

export const MyLink = forwardRef<HTMLAnchorElement, NextLinkProps & React.AnchorHTMLAttributes<HTMLAnchorElement>>(({ href, onClick, children, ...props }, ref) => {
    const router = useRouter();
    const isExternal = typeof href === 'string' && (href.startsWith('http') || href.startsWith('//'));

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (!href) return;
        if (isExternal) {
            return; 
        }
        e.preventDefault();
        // if (router.isRouterReady) {
        router.push(href).then((success) => {
            if (success !== false && onClick) onClick(e);
        });
        // } else if (onClick) {
        //     onClick(e);
        // }
    };

    // Ensure children is a valid ReactElement before applying props
    const child = React.Children.only(children) as ReactElement;

    return (
        // <NextLink href={href} {...props}>o
        //     {cloneElement(child, {
        //         ref,
        //         onClick: handleClick,
        //         ...child.props, // Preserve existing child props
        //     })}
        // </NextLink>
        <NextLink href={href} {...props}>
            <a ref={ref} onClick={handleClick} {...props}>
                {child}
            </a>
        </NextLink>
    );
});

MyLink.displayName = 'Link';
